<template>
  <app-auth-redirect
    redirect-text="Redirecting to sign in..."
    redirect-type="signIn"
  />
</template>
